import { ImgProps } from "assets/images/types";

export default function ImgTodasAsFloresMain(props: ImgProps) {
	const { height = 259, width = 518 } = props;
	return (
		<img
			src="/assets/images/cases/todas-as-flores/todas-as-flores-card.webp"
			alt="Natura Todas as Flores"
			loading="eager"
			width={width}
			height={height}
		/>
	);
}
